<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="edu in items"
            :key="edu.id"
            cols="12"
            sm="6"
            md="4"
            class="d-flex align-items-stretch"
          >
            <v-card variant="flat" class="my-4 flex-grow-1 app-content-card">
              <v-card-text class="text-left">
                <h3>{{ $t("candidateTabs.education.specificity") }}: {{ edu.Specificity }}</h3>
                <v-divider></v-divider>
                <p>
                  <strong>{{ $t("candidateTabs.education.type") }}:</strong>
                  {{ edu.Education_type }}
                </p>
                <p>
                  <strong>{{ $t("candidateTabs.education.description") }}:</strong> {{ edu.Description }}
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn icon @click="openEditEducationDialog(edu)">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="confirmDeleteEducation(edu.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-btn
          color="primary"
          @click="openAddEducationDialog"
          class="mb-4 d-flex align-items-stretch"
        >
          {{ $t("candidateTabs.education.addButton") }}
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addEducationDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.education.addTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="addEducation">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select :items="educationTypeOptions" :label="`${$t('candidateTabs.education.type')} *`" v-model="newEducation.Education_type" :rules="[rules.required]" outlined required></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.education.specificity')} *`" v-model="newEducation.Specificity" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea :label="$t('candidateTabs.education.description')" v-model="newEducation.Description" outlined></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.add") }}</v-btn>
                  <v-btn variant="text" @click="closeAddEducationDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editEducationDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.education.editTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="updateEducation">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select :items="educationTypeOptions" :label="`${$t('candidateTabs.education.type')} *`" v-model="editEducation.Education_type" :rules="[rules.required]" outlined required></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field :label="`${$t('candidateTabs.education.specificity')} *`" v-model="editEducation.Specificity" :rules="[rules.required]" outlined required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea :label="$t('candidateTabs.education.description')" v-model="editEducation.Description" outlined></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.save") }}</v-btn>
                  <v-btn variant="text" @click="closeEditEducationDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

// Education CRUD tab extracted from CandidateDetails.vue.
export default defineComponent({
  name: "CandidateEducationTab",
  props: {
    candidateId: { type: [String, Number], required: true },
    items: { type: Array, default: () => [] },
  },
  emits: ["refresh", "notify"],
  data() {
    return {
      // Valori de enum stocate în DB — se păstrează stabile (nu se localizează valoarea).
      educationTypeOptions: ["Liceu", "Universitate", "Postuniversitar", "Altele"],
      addEducationDialog: false,
      newEducation: { Education_type: "", Specificity: "", Description: "" },
      editEducationDialog: false,
      editEducation: { id: null, Education_type: "", Specificity: "", Description: "" },
    };
  },
  computed: {
    rules() {
      return { required: (value) => !!value || this.$t("candidateTabs.common.requiredField") };
    },
  },
  methods: {
    openAddEducationDialog() {
      this.newEducation = { Education_type: "", Specificity: "", Description: "" };
      this.addEducationDialog = true;
    },
    closeAddEducationDialog() {
      this.addEducationDialog = false;
    },
    addEducation() {
      if (!this.newEducation.Education_type.trim() || !this.newEducation.Specificity.trim()) {
        this.$emit("notify", { message: this.$t("candidateTabs.common.requiredEmpty"), color: "error" });
        return;
      }
      const payload = {
        id_foreign: this.candidateId,
        Education_type: this.newEducation.Education_type,
        Specificity: this.newEducation.Specificity,
        Description: this.newEducation.Description || null,
      };
      axios
        .post("/candidati/education", payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.education.added"), color: "success" });
          this.addEducationDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la adăugarea educației:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.education.addError"), color: "error" });
        });
    },
    openEditEducationDialog(education) {
      this.editEducation = { ...education };
      this.editEducationDialog = true;
    },
    closeEditEducationDialog() {
      this.editEducationDialog = false;
    },
    updateEducation() {
      if (!this.editEducation.Education_type.trim() || !this.editEducation.Specificity.trim()) {
        this.$emit("notify", { message: this.$t("candidateTabs.common.requiredEmpty"), color: "error" });
        return;
      }
      const educationId = this.editEducation.id;
      const payload = {
        id_foreign: this.candidateId,
        Education_type: this.editEducation.Education_type,
        Specificity: this.editEducation.Specificity,
        Description: this.editEducation.Description || null,
      };
      axios
        .put(`/candidati/education/${educationId}`, payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.education.updated"), color: "success" });
          this.editEducationDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la actualizarea educației:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.education.updateError"), color: "error" });
        });
    },
    confirmDeleteEducation(id) {
      if (confirm(this.$t("candidateTabs.education.deleteConfirm"))) {
        this.deleteEducation(id);
      }
    },
    deleteEducation(id) {
      axios
        .delete(`/candidati/education/${id}`)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.education.deleted"), color: "success" });
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la ștergerea educației:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.education.deleteError"), color: "error" });
        });
    },
  },
});
</script>
